/**
 * Represents a zeus.apollon_fk_conf.conf.projekt.feldgruppen value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, Model, type MutationsObject } from '@kp/js-model';
import { ProjektFeld } from '@/models/apollon_conf_fk/ProjektFeld';
import dayjs, { Dayjs } from 'dayjs';

export class ProjektFeldGruppe extends Model {
    public label: string | null = null
    public einreichung: boolean = false
    public einreichung_from: Dayjs | null = null
    public einreichung_to: Dayjs | null = null
    public abschluss: boolean = false
    public abschluss_from: Dayjs | null = null
    public abschluss_to: Dayjs | null = null
    public hilfetext: string | null = null
    public felder: ProjektFeld[] = []

    mutations(): MutationsObject {
        return {
            felder: (val: Record<string, any>[]) => (val ? val.map((feld) => createModel(ProjektFeld, feld)) : []),
            einreichung_from: (date: Dayjs | null) => (date ? dayjs(date) : null),
            einreichung_to: (date: Dayjs | null) => (date ? dayjs(date) : null),
            abschluss_from: (date: Dayjs | null) => (date ? dayjs(date) : null),
            abschluss_to: (date: Dayjs | null) => (date ? dayjs(date) : null)
        };
    }
}
